import { GetUnReadNotificationMessages } from "_graphql/queries/__generated__/GetUnReadNotificationMessages";
import { getUnReadNotificationMessages } from "_graphql/visal/queries/unread-notification-messages";
import { isDevelopment } from "utils";
import { useQuery } from "@apollo/client";

export const useUnreadNotificationMessages = () => {
  const { data, loading, ...rest } = useQuery<GetUnReadNotificationMessages>(
    getUnReadNotificationMessages,
    {
      fetchPolicy: "network-only",
      // pollInterval: isDevelopment ? undefined : 10000,
    }
  );

  return {
    unreadNotificationMessages: data?.getUnReadNotificationMessages || [],
    loading,
    ...rest
  };
};
